"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidesPage = void 0;
require("../../css/slides-page.scss");
var IframeComms = require("../frame-comms/iframe-comms");
var SlidesPage = /** @class */ (function () {
    function SlidesPage() {
    }
    SlidesPage.init = function (memberNr, ServerContentLoaded) {
        SlidesPage.initComponent();
    };
    SlidesPage.initComponent = function () {
        //styles
        var categories = $("#categories-menu .category-item");
        var numCategories = categories.length;
        var colSize = 12 / numCategories;
        $("#slides-page-container .item").addClass("col-sm-" + colSize);
        //show the view
        $("#slides-page").show();
        SlidesPage.scrollUpWhenClicked();
    };
    SlidesPage.scrollUpWhenClicked = function () {
        $(".slide-item a").on("click", function (e) {
            IframeComms.propagateHeight(true);
        });
    };
    return SlidesPage;
}());
exports.SlidesPage = SlidesPage;
